/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ScaleOralPosterPresentation = ({ rowData }) => {
  const classes = useStyles();
  return (
    <div className={classes.gradeDetails}>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Qualité du poster :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.posterQuality || '0'}
          /2.5
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Qualité de la présentation :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.presentationQuality || '0'}
          /2.5
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Grammaire et syntaxe :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.languageMastery || '0'}
          /5
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.resultDetail}>
          Vocabulaire médical :
        </Typography>
        <Typography className={classes.resultDetail}>
          {rowData?.grade?.vocabulary || '0'}
          /10
        </Typography>
      </div>
      <div className={classes.resultRow}>
        <Typography className={classes.totalGrade}>
          Total :
        </Typography>
        <Typography className={classes.totalGrade}>
          {parseFloat(rowData?.grade?.vocabulary || 0)
            + parseFloat(rowData?.grade?.languageMastery || 0)
            + parseFloat(rowData?.grade?.presentationQuality || 0)
            + parseFloat(rowData?.grade?.posterPresentation || 0)}
          /20
        </Typography>
      </div>
    </div>
  );
};

export default ScaleOralPosterPresentation;
